import { AiOutlineFieldTime } from "react-icons/ai";
import { BiMedal } from "react-icons/bi";
import { FaLaptopHouse } from "react-icons/fa";
import styled from "styled-components";

const PreFooter = () => {
  return (
    <Container>
      <div className="layout">
        <div>
          <BiMedal />
          <section>
            <h4>رتبه یک سفر</h4>
            <p>رتبه یک سفر معتبرترین عرضه‌کننده محصولات گردشگری در ایران</p>
          </section>
        </div>
        <div>
          <FaLaptopHouse />
          <section>
            <h4>همسفر هر سفر</h4>
            <p>ارائه تمامی خدمات سفر (پرواز، قطار، اتوبوس، هتل و تور)</p>
          </section>
        </div>
        <div>
          <AiOutlineFieldTime />
          <section>
            <h4>همسفر همه لحظات سفر</h4>
            <p>پشتیبانی و همراهی ۲۴ ساعته در تمامی مراحل سفر</p>
          </section>
        </div>
      </div>
    </Container>
  );
};

export default PreFooter;

const Container = styled.div`
  background-color: #ffff;
  margin: 35px auto 0 auto;
  display: flex;
  justify-content: space-around;
  direction: rtl;

  .layout {
    width: 1120px;
    padding: 40px;

    @media (max-width: 900px) {
      width: 100vw;
      flex-direction: column;
      padding: 0 5px;
      margin: 0;
    }
  }

  div {
    display: flex;
    margin: 0 20px;

    @media (max-width: 900px) {
      margin-top: 10px;
       &:last-child{
        margin-bottom: 10px;
       }
    }

    section {
      h4 {
        font-size: 18px;
        color: #5f5f5f;
      }

      p {
        font-size: 16px;
        color: gray;
      }
    }

    svg {
      color: #e73511;
      font-size: 90px;
      margin: 0 10px;
      vertical-align: top;
      
      @media (max-width: 900px) {
        font-size: 50px;
      }
    }
  }
`;
